module.exports = __webpack_public_path__ + "img/2.51e046f3.png";